import React from 'react';
// After this code is moved out to DPC, we can drop this import and uncomment the implementation.
// eslint-disable-next-line @dropbox/sign/isolate-folder
import * as baseFeatureFlags from 'js/sign-components/common/feature-flag';

export type SignerAppFeatureFlags = Partial<{
  /* eslint-disable camelcase */
  // this looks odd maybe but signature modal is used outside of the signer, too
  sign_core_20240330_new_signer_app: boolean;
  sign_core_2025_11_20_text_field_scaling: boolean;
  sign_core_2025_02_25_new_upload_signature_component: boolean;
  sign_core_2026_03_02_fix_finalize_saving_race: boolean;
  sign_core_2026_03_04_prefill_fields: boolean;
  sign_core_2026_03_10_encode_api_ids_in_signer_app: boolean;
  sign_core_2026_03_24_white_labeling_signature_modal: boolean;
  sign_core_2026_03_31_use_built_in_retry_for_ready: boolean;
  sign_core_2026_03_25_white_labeling_new_signer_app_text_color_fix: boolean;
  sign_core_2026_03_03_fix_group_requirement_invariant: boolean;
  /* eslint-enable camelcase */
}>;

// const {
//   useContext: useFeatureFlags,
//   Provider,
// } = createSimpleDataContext<SignerAppFeatureFlags>('FeatureFlags');

export function FeatureFlagProvider({
  children,
  featureFlags,
}: React.PropsWithChildren<{ featureFlags: SignerAppFeatureFlags }>) {
  return (
    <baseFeatureFlags.FeatureFlagProvider featureFlags={featureFlags as any}>
      {children}
    </baseFeatureFlags.FeatureFlagProvider>
  );
}

export function useFeatureFlag(name: keyof SignerAppFeatureFlags) {
  return baseFeatureFlags.useFeatureFlag(name);
  // const context = useFeatureFlags();
  // return Boolean(context[name]);
}
